// Version : 0.0.1
// Author : SATHISH
// LastEdit : SATHISH
//Last ADD : NEW'
// MODFIED DATA : 18-08-2025
import { makeApiCall } from '../../_common/api.utils';
import { API_URL } from '../../const';

/*************** Get Auto Loan Collection Report Details Start ******************/
export const autoLoanCollectionReportDetailsGet = (listData: any) => {
	const data = {
		GetAutoLoanCollectionReportJson: listData,
	};
	const url = `${API_URL}autoLoanCollectionReport`;
	return makeApiCall(url, data);
};
/*************** Get Auto Loan Collection Report Details End ******************/
